import Circle from "../../images/chart.svg";
const CircleChart = () => {
  return <img src={Circle} />;
};
export default CircleChart;
